import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const BackButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Button
      onClick={() => navigate(-1)}
      style={{
        marginTop: "1rem",
        float: "left",
      }}
    >
      {t("back")}
    </Button>
  );
};
